import { shouldBlockByDateDocumentsLimit } from "@helpers/ShouldBlockByDateDocumentsLimit";
import { startGetLoginUrl } from "@redux/slices/students/moodle";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHasPermission } from "../../../../hooks/useHasPermission";
import { IconApp } from "../../../IconApp";
import { NavLinkApp } from "../../../NavLinkApp";

export const Modules_Students = () => {
    const dispatch = useDispatch();

    const { hasPermission } = useHasPermission();

    const { tiny_name } = useSelector((state) => state.config);
    const { session, user } = useSelector((state) => state.auth);

    const [blockByDateDocumentsLimit, setBlockByDateDocumentsLimit] = useState({
        shouldBlock: true,
        cycleDateDocumentsLimit: null,
        isDebtorDocuments: true,
    });

    //* Si el estatus del alumno es cualquiera de baja, ocultarle módulos académicos (solo mostrar cobranza)
    const canSeeAcademicModules = ![
        "BAJA DEFINITIVA",
        "BAJA TEMPORAL",
        "BAJA ACADEMICA",
        "BAJA ADEUDO BIBLIOTECA",
        "BAJA POR ADEUDO",
        "BAJA POR DOCUMENTOS",
        "BAJA INFORMAL",
        "SERVICIO SOCIAL",
        "SUSPENDIDO",
    ].includes(user.status);

    const showGraduationOptionRequestModule = useMemo(() => {
        // return true;

        //? Descomentar todo el bloque de abajo para habilitarlo correctamente
        if (tiny_name !== "EAD") {
            return false;
        }

        if (
            user?.curriculum?.graduation_option_type ===
            "Formularios de tesis para 7 8 y 9"
        ) {
            return ["06", "07", "08", "09"].includes(user?.degree);
        } else if (
            user?.curriculum?.graduation_option_type ===
            "Configuración de opciones y requisitos"
        ) {
            return user?.status === "EGRESADO";
        } else {
            return false;
        }
    }, [user]);

    //* Usar el helper que determina el bloque por fecha límite para entrega de documentos
    useEffect(() => {
        let mounted = true;

        const fetchBlockInfo = async () => {
            const result = await shouldBlockByDateDocumentsLimit(
                user,
                tiny_name
            );

            if (mounted) {
                setBlockByDateDocumentsLimit(result);
            }
        };

        if (user) {
            fetchBlockInfo();
        }

        return () => {
            mounted = false;
        };
    }, [user]);

    const handleMoodleLogin = () => {
        dispatch(startGetLoginUrl(user.id));
    };

    return (
        <div>
            {session === "student" && !!user.moodle && (
                <NavLinkApp
                    name="Aulas virtuales"
                    onClick={handleMoodleLogin}
                    icon={
                        <IconApp iconClassName="fa-solid fa-graduation-cap c-sidebar-nav-icon" />
                    }
                />
            )}

            {hasPermission("SESSION_STUDENT") &&
                !blockByDateDocumentsLimit?.shouldBlock && (
                    <NavLinkApp
                        name="Aclaraciones"
                        to="/students/aclarations"
                        icon={
                            <IconApp iconClassName="fa-solid fa-message-exclamation  c-sidebar-nav-icon" />
                        }
                    />
                )}

            {hasPermission("SESSION_STUDENT") &&
                canSeeAcademicModules &&
                !blockByDateDocumentsLimit?.shouldBlock && (
                    <NavLinkApp
                        name="Calificaciones"
                        to="/students/grades"
                        icon={
                            <IconApp iconClassName="fa-solid fa-star  c-sidebar-nav-icon" />
                        }
                    />
                )}

            {tiny_name != "EAD" &&
                hasPermission("SESSION_STUDENT") &&
                canSeeAcademicModules &&
                !blockByDateDocumentsLimit?.shouldBlock && (
                    <NavLinkApp
                        name="Asistencias y faltas"
                        to="/students/attendances"
                        icon={
                            <IconApp iconClassName="fa-solid fa-clipboard-list-check c-sidebar-nav-icon" />
                        }
                    />
                )}

            {hasPermission(["SESSION_STUDENT"]) &&
                canSeeAcademicModules &&
                !blockByDateDocumentsLimit?.shouldBlock && (
                    <NavLinkApp
                        name="Becas"
                        to="/students/scholarship-request/screen"
                        icon={
                            <IconApp iconClassName="fa-solid fa-badge-percent c-sidebar-nav-icon" />
                        }
                    />
                )}

            {hasPermission("SESSION_STUDENT") &&
                !["EGRESADO", "GRADUDADO"].includes(user.status) && (
                    <NavLinkApp
                        name="Documentación"
                        to="/students/load-documents"
                        icon={
                            <IconApp iconClassName="fa-regular fa-folder-open  c-sidebar-nav-icon" />
                        }
                    />
                )}

            {hasPermission("SESSION_STUDENT") &&
                (!blockByDateDocumentsLimit?.shouldBlock ||
                    !blockByDateDocumentsLimit?.isDebtorDocuments) && (
                    <NavLinkApp
                        name="Estado de cuenta"
                        to="/students/billing/status"
                        icon={
                            <IconApp iconClassName="fa-solid fa-money-check-dollar c-sidebar-nav-icon" />
                        }
                    />
                )}

            {hasPermission("SESSION_STUDENT") && (
                <NavLinkApp
                    name="Examenes y encuestas"
                    to="/my/surveys"
                    icon={
                        <IconApp iconClassName="fa-solid fa-clipboard-list-check  c-sidebar-nav-icon" />
                    }
                />
            )}

            {hasPermission("SESSION_STUDENT") &&
                (!blockByDateDocumentsLimit?.shouldBlock ||
                    !blockByDateDocumentsLimit?.isDebtorDocuments) && (
                    <NavLinkApp
                        name="Historial de pagos"
                        to="/students/billing/payments-history"
                        icon={
                            <IconApp iconClassName="fa-solid fa-envelope-open-dollar  c-sidebar-nav-icon" />
                        }
                    />
                )}

            {hasPermission("SESSION_STUDENT") &&
                canSeeAcademicModules &&
                !blockByDateDocumentsLimit?.shouldBlock && (
                    <NavLinkApp
                        name="Horarios"
                        to="/students/schedule/screen"
                        icon={
                            <IconApp iconClassName="fa-solid fa-calendar-days c-sidebar-nav-icon" />
                        }
                    />
                )}

            {hasPermission(["SESSION_STUDENT"]) &&
                tiny_name !== "EAD" &&
                user?.curriculum &&
                ["Licenciatura", "Maestría", "Doctorado"].includes(
                    user.curriculum?.level
                ) && (
                    <NavLinkApp
                        name="Programa Apoyo Universitario"
                        to="/students/educational-credits"
                        icon={
                            <IconApp iconClassName="fa-solid fa-hand-holding-dollar c-sidebar-nav-icon" />
                        }
                    />
                )}

            {tiny_name !== "EAD" &&
                hasPermission(["SESSION_STUDENT"]) &&
                canSeeAcademicModules &&
                !blockByDateDocumentsLimit?.shouldBlock && (
                    <NavLinkApp
                        name="Servicio y prácticas"
                        to="/students/internship"
                        icon={
                            <IconApp iconClassName="fa-solid fa-regular fa-briefcase c-sidebar-nav-icon" />
                        }
                    />
                )}

            {hasPermission("SESSION_STUDENT") &&
                (!blockByDateDocumentsLimit?.shouldBlock ||
                    !blockByDateDocumentsLimit?.isDebtorDocuments) && (
                    <NavLinkApp
                        name="Servicios escolares"
                        to="/students/extra-payments/screen"
                        icon={
                            <IconApp iconClassName="fa-solid fa-basket-shopping  c-sidebar-nav-icon" />
                        }
                    />
                )}

            {hasPermission("SESSION_STUDENT") &&
                showGraduationOptionRequestModule && (
                    <NavLinkApp
                        name="Solicitar opción de titulación"
                        to="/students/graduations-option-request"
                        icon={
                            <IconApp iconClassName="fa-solid fa-graduation-cap  c-sidebar-nav-icon" />
                        }
                    />
                )}
        </div>
    );
};
